import { useEffect } from 'react';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import axios from 'axios';

/**
 * Component that initializes Fingerprint.js and sets up headers for API requests
 * This should be included near the root of your app
 */
const FingerprintInitializer = () => {
  useEffect(() => {
    const initializeFingerprint = async () => {
      try {
        // Initialize an agent
        const fpPromise = FingerprintJS.load();
        const fp = await fpPromise;
        
        // Get the visitor identifier
        const result = await fp.get();
        const visitorId = result.visitorId;
        
        // Store it for later use with axios
        // Set as default header for all requests
        axios.defaults.headers.common['X-Browser-ID'] = visitorId;
        
        console.log('Fingerprint initialized successfully');
      } catch (error) {
        console.error('Error initializing fingerprint:', error);
      }
    };

    initializeFingerprint();
  }, []);

  // This component doesn't render anything
  return null;
};

export default FingerprintInitializer;